import { IMetropolitanArea } from "../interfaces/iMetropolitanArea";

export class MetropolitanArea implements IMetropolitanArea {
	public key: string = "";
	public name: string = "";
	public isCurrent: boolean = false;

	constructor(metropolitanArea: IMetropolitanArea = {} as IMetropolitanArea) {
		this.key = metropolitanArea.key;
		this.name = metropolitanArea.name;
		this.isCurrent = !!metropolitanArea.isCurrent;
	}
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/metropolitanArea.ts